import _ from "lodash";
import axios from "axios";

const actions = {
    checkExistingUserFromProvidedData({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post("/check_existing_user", payload)
                .then((res) => {
                    commit("mutateStep2Data", payload);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    checkExistingLocationFromProvidedData({ }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post("/check_existing_location", payload)
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    resendVerificationCode({ state }) {
        const { countryId, cpf, ssn, passport, email, mobile } = state.requestData;
        return new Promise((resolve, reject) => {
            axios
                .post("/verification_code", {
                    country_id: countryId,
                    cpf,
                    ssn,
                    passport,
                    email,
                    mobile,
                })
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    generateTerms({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post("/free_registration_terms", payload)
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    sign({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .post("/sign_free_registration_terms", payload)
                .then((res) => {
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default actions;
